export default '/build/f7488798.svg'